import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { MaterialModule } from '../../material.module';
import { AppAdminsitratorAirportSitaComponent } from './app-administrator-airport-sita.component';
import { AppModalDeletedSitaComponent } from './app-modal-deleted-sita/app-modal-deleted-sita.component';

@NgModule({
  declarations: [
    AppAdminsitratorAirportSitaComponent,
    AppModalDeletedSitaComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    MaterialModule,
  ],
  exports: [
    AppAdminsitratorAirportSitaComponent,
  ],
})
export class AppAdministratorAirportSitaModule { }
